jQuery(document).ready(function ($) {
    $(".header_inner ul.primary-menu>.menu-item-has-children").hover(
        function () {
            if ($(this).find('ul.sub-menu').is(":hidden")) {
                $(this).addClass("hover");
                $(this).find('ul.sub-menu').slideDown('100');
            }
        },
        function () {
            if ($(this).find('ul.sub-menu').is(":visible")) {
                $(this).removeClass("hover");
                $(this).find('ul.sub-menu').slideUp('100');
            }
        }
    );

    if ($(window).width() < 767) {
        $(".footer_inner__col:not(.col6) .heading").click(function () {
            $(this).toggleClass('open').next().slideToggle();
        });
    }

    $('.customSelect').selectric({
        maxHeight: 500,
        disableOnMobile: false,
        nativeOnMobile: false
        /* onChange: function(element) {
            $(element).change();
        }, */
    });

    /* $( document ).ajaxComplete(function() {
        $('.customSelect').selectric('refresh');        
    });
    $(document).on('gform_page_loaded', function(event, form_id, current_page){
        $('.customSelect').selectric('refresh');
    }); */

    $('.our_partners__list').slick({
        dots: true,
        arrows: false,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 6000,
    });

    $('.home_hero_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
    });

    $('.accordian__item').each(function () {
        $(this).find('.accordian__heading').on('click', function () {
            $(this).next().slideToggle();
            let itemTo = $('.accordian__heading.opened').not($(this));
            $(itemTo).next().slideToggle();
            $(itemTo).removeClass('opened');
            $('.accordian__heading.opened').next().slideToggle();
            $(this).toggleClass('opened');
        });
    })

    $('.statistics_component__list').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        // slidesToScroll: 5,
        prevArrow: $('.slickprev'),
        nextArrow: $('.slicknext'),
        responsive: [{
                breakpoint: 1441,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 321,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    if ($('.section .filterPost').length > 0) {

        $("body").on("click", ".filterPost .pagination li:not(.disable) > a.pbtn", function (event) {
            event.preventDefault();
            var paged = $(this).attr('data-paged'),
                sort_by = $('form.filter_section select#sort_by').val(),
                type = $('form.filter_section select#type').val(),
                research_area = $('form.filter_section select#research_area').val(),
                ss = $('form.filter_section input.search_post').val();
            filter_post(paged, sort_by, type, research_area, ss);
        });

        $("body").on("change", "form.filter_section select#sort_by", function () {
            var type = $('form.filter_section select#type').val(),
                research_area = $('form.filter_section select#research_area').val();
                console.info($(this).val());
            filter_post(1, $(this).val(), type, research_area);
        });

        $("body").on("change", "form.filter_section select#type", function () {
            var sort_by = $('form.filter_section select#sort_by').val(),
                research_area = '';
            // research_area = $('form.filter_section select#research_area').val();
            $('form.filter_section input.search_post').val('');
            $('form.filter_section select#research_area').prop('selectedIndex', 0).selectric('refresh');
            filter_post(1, sort_by, $(this).val(), research_area);
        });

        $("body").on("change", "form.filter_section select#research_area", function () {
            $(this).selectric('close');
            $('form.filter_section input.search_post').val('');
            var sort_by = $('form.filter_section select#sort_by').val(),
                type = $('form.filter_section select#type').val();
            filter_post(1, sort_by, type, $(this).val());
        });

        var search = '';
        $("form.filter_section input.search_post").keyup(function () {
            $('form.filter_section select#research_area, form.filter_section select#type').prop('selectedIndex', 0).selectric('refresh');
            var ss = $(this).val(),
                sort_by = $('form.filter_section select#sort_by').val();
            clearTimeout(search);
            // if (ss) {
            search = setTimeout(function () {
                filter_post(1, sort_by, '', '', ss);
            }, 600);
            // }
        });
    }

});


function filter_post(paged = 1, sort_by = 'DESC', term_id = '', research_area = '', ss = '') {
    jQuery('body').addClass('loading');

    var post_type = jQuery('form.filter_section > input[name="post_type"]').val();
    var post_count = jQuery('form.filter_section > input[name="post_count"]').val();
    if (term_id == '') {
        term_id = jQuery('form.filter_section > input[name="term_id"]').val();
    }
    jsonObj = {
        "action": "filter_post",
        "post_type": post_type,
        "post_count": post_count,
        "paged": paged,
        "sort_by": sort_by,
        "term_id": term_id,
        "research_area": research_area,
        "s": ss,
    };

    jQuery.ajax({
        url: ajax_call_url,
        data: jsonObj, // form data
        type: "POST", // POST
        // async: true,
        beforeSend: function (xhr) {
            // console.log("ajax start"); // changing the button label
        },
        success: function (xhr) {
            if (xhr.success === true) {
                jQuery('.filterPost #postList').html(xhr.data.list);
                jQuery('.filterPost .pagination').html(xhr.data.pagination);
                if (jQuery(".filterPost .filter_section").length > 0) {
                    // setTimeout(function () {
                    jQuery("body,html").animate({
                        scrollTop: jQuery(".filterPost .filter_section").offset().top - 200
                    }, 1000)
                    // }, 500);
                }
            }
            jQuery('body.loading').removeClass('loading');
        },
        error: function (xhr) {
            console.log(xhr);
            jQuery('body.loading').removeClass('loading');
        }
    });

}